import axios from 'axios';
import * as XLSX from 'xlsx';

const getJsonFromSheet = async (url) => {
  try {
    const response = await axios.get(url, { responseType: 'arraybuffer' });

    const data = new Uint8Array(response.data);
    const workbook = XLSX.read(data, { type: 'array' });

    const allSheetsData = {};

    workbook.SheetNames.forEach(sheetName => {
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      allSheetsData[sheetName] = jsonData;
    });

    return allSheetsData;

  } catch (error) {
    console.error('Error fetching or parsing Excel file:', error);
  }
};

export { getJsonFromSheet };

// import axios from 'axios';
// import * as XLSX from 'xlsx';

// const getJsonFromSheet = async (url) => {
//     try {
//     //   const url = 'http://localhost:3000/data/Floorplans.xlsx';
//       const response = await axios.get(url, { responseType: 'arraybuffer' });

//       const data = new Uint8Array(response.data);
//       const workbook = XLSX.read(data, { type: 'array' });

//       const sheetName = workbook.SheetNames[0];
//       const sheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(sheet);

//       return jsonData;

//     } catch (error) {
//       console.error('Error fetching or parsing Excel file:', error);
//     }
//   };

//   export {getJsonFromSheet}
